<template>
  <zm-modal
    :title="title"
    :size="size"
    :visible="visible"
    :footer="false"
    @cancel="cancel">
    <div slot="modalBody">
      <div class="zm-form">
        <a-form :form="form" @submit="handleSubmit">
          <div class="subtitle">
            <div class="formTitle"></div>
            <div class="formTitleText">发票详情</div>
          </div>
          <a-row>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称" hasFeedback>
                <a-select
                  @change="partyChange"
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择销售合同"
                  v-decorator="['contractId', { rules: [{ required: true, message: '请选择销售合同！' }] }]"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in contractList" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
                <a-input
                  placeholder="自动导入合同金额"
                  addon-after="元"
                  disabled
                  autocomplete="off"
                  v-decorator="['contractMoney', { rules: [{ required: true, message: '自动导入合同金额！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人" hasFeedback>
                <a-select
                  @change="operatorIdChange"
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择经办人"
                  v-decorator="['operatorId', { rules: [{ required: true, message: '请选择经办人！' }] }]"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in operatorList" :key="index">
                    {{ item.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="甲方名称">
                <a-input
                  placeholder="自动导入甲方名称"
                  disabled
                  autocomplete="off"
                  v-decorator="['companyName', { rules: [{ required: true, message: '自动导入甲方名称！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票类型" hasFeedback>
                <a-select
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择发票类型"
                  v-decorator="['invoiceType', { rules: [{ required: true, message: '请选择发票类型！' }] }]"
                >
                  <a-select-option :value="item.code" v-for="(item, index) in invoiceTypeList" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票日期">
                <a-date-picker
                  style="width: 100%"
                  placeholder="请选择发票日期"
                  :disabled="!isEdit"
                  format="YYYY-MM-DD"
                  v-decorator="['invoiceTime', { rules: [{ required: true, message: '请选择发票日期！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="税点" hasFeedback>
                <a-select
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择税点"
                  v-decorator="['taxPoint', { rules: [{ required: true, message: '请选择税点！' }] }]"
                >
                  <a-select-option :value="item.code" v-for="(item, index) in taxPointTypeList" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开票金额">
                <a-input
                  placeholder="请输入开票金额"
                  autoComplete="off"
                  addon-after="元"
                  :disabled="!isEdit"
                  v-decorator="['invoiceMoney', { rules: [{ required: true, message: '请输入开票金额！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="发票附件">
                <a-button class="packageDownload" v-if="downloadZipShow" @click="downloadZip">打包下载文件</a-button>
                <zm-preview
                  v-if="type == $sysInfo.MODAL_VIEW"
                  :list="fileList"
                  :previewUrl="$sysInfo.previewUrl"
                  :baseUrl="$sysInfo.apiRemote"
                  :account="$sysInfo.previewAccount"
                  :token="$sysInfo.previewToken"
                  :jwtToken="$store.state.user.token"
                  downloadUrl="/invoice/file/"
                ></zm-preview>
                <zm-upload
                  v-else
                  ref="uploader"
                  title="上传"
                  :baseUrl="$sysInfo.apiRemote"
                  :headers="headers"
                  :list="fileList"
                  acceptType="pdf,jpeg,jpg,png"
                  @handleUpload="handleUpload"
                  :isEdit="isEdit"
                  v-decorator="['fileList', { rules: [{ required: true, message: '请上传文件！' }] }]"
                ></zm-upload>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <div class="subtitle">
              <div class="formTitle"></div>
              <div class="formTitleText">关联收款信息</div>
            </div>
            <a-col :span="24">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="已收款">
                <a-switch :disabled="!isEdit" @change="changePayState" v-decorator="['payState', { valuePropName: 'checked',rules: [{ required: true, message: '请选择是否已收款！' }] }]"/>
                <span style="display: inline-block;margin-left: 10px;font-size: 14px" v-if="payState">是</span>
                <span style="display: inline-block;margin-left: 10px;font-size: 14px" v-else>否</span>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-show="collectionShow">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="关联收款" hasFeedback>
                <a-select
                  filterable
                  :disabled="!isEdit"
                  mode="multiple"
                  placeholder="请选择收款编号及金额"
                  v-decorator="['invoicePayList', { rules: [{ required: collectionShow, message: '请选择收款编号及金额！' }] }]"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in collectionList" :key="index">
                    {{ item.payNo }}/{{ item.payMoney }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <div style="text-align:right">
                <a-button
                  type="primary"
                  html-type="submit"
                  style="margin-right:10px;"
                  v-if="this.type !== this.$sysInfo.MODAL_VIEW"
                >
                  保存
                </a-button>
                <a-button @click="cancel">取消</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
  </zm-modal>
</template>

<script>
import moment from 'moment'
import Uploader from '@/CrComponents/Uploader'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { getHandlerList } from '@/api/business/collection'
import { getInvoice, controlInvoice, downloadInvoiceFile, getContractsSell, getCollection } from '@/api/business/invoice'
import { getDictInfoByCode } from '@/api/dict'

export default {
  name: 'EditProprietors',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    checkAble () {
      if (this.isEdit && this.able) {
        return false
      } else {
        return true
      }
    }
  },
  components: {
    baseModal,
    Uploader
  },
  data () {
    return {
      title: '操作',
      size: 'large',
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      form: this.$form.createForm(this, { name: 'proprietors' }),
      visible: false,
      model: {},
      headers: {
        Authorization: this.$store.state.user.token
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      able: false,
      // 附件
      fileList: [],
      contractDetail: {},
      // 合同名称
      contractName: '',
      // 甲方id
      companyId: '',
      // 经办人姓名
      operatorName: '',
      // 是否已收款
      payState: false,
      // 是否显示打包下载按钮
      downloadZipShow: false,
      // 销售合同下拉数据
      contractList: [],
      // 发票类型数据
      invoiceTypeList: [],
      // 税点下拉数据
      taxPointTypeList: [],
      // 经办人下拉数据
      operatorList: [],
      // 关联收款下拉数据
      collectionList: [],
      // 关联收款是否显示
      collectionShow: false
    }
  },
  mounted () {
    // 获取下拉列表数据
    this.getDropdownListData()
  },
  methods: {
    // 设置类型insta
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
      if (this.model) {
        this.downloadZipShow = true
      } else {
        this.downloadZipShow = false
      }
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        if (this.type !== this.$sysInfo.MODAL_ADD) {
          this.getModelInfo()
        } else {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              payState: false,
              invoiceTime: this.getToday()
            })
          })
        }
      }
    },
    // 获取当天日期
    getToday () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${year}-${month}-${day}`
    },
    // 获取下拉列表数据
    getDropdownListData () {
      // 获取销售合同列表
      getContractsSell({ paging: false }).then(res => {
        this.contractList = res.data
      })
      // 获取发票类型列表
      getDictInfoByCode({ pCode: 'INVOICE_TYPE' }).then(res => {
        this.invoiceTypeList = res.data
      })
      // 获取税点下拉数据
      getDictInfoByCode({ pCode: 'TAX_POINT_TYPE' }).then(res => {
        this.taxPointTypeList = res.data
      })
      // 获取经办人
      getHandlerList().then(res => {
        this.operatorList = res.data
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()

      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          this.form.validateFieldsAndScroll((err, value) => {
            if (!err) {
              if (!value.payState) {
                delete value.invoicePayList
              }
              var params = { ...value }
              if (this.fileList.length) {
                params.fileList = this.fileList
              }
              if (this.type === this.$sysInfo.MODAL_MODIFY) {
                params.id = this.model.id
              }
              // 甲方id
              params.companyId = this.companyId
              // 合同名称
              params.contractName = this.contractName
              // 经办人姓名
              params.operatorName = this.operatorName
              // 时间
              params.invoiceTime = moment(params.invoiceTime).format('YYYY-MM-DD')
              // 收款id
              if (params.invoicePayList) {
                params.invoicePayList = params.invoicePayList.map(item => {
                  return { payId: item }
                })
              }
              params.type = 2
              // return
              controlInvoice(params).then(res => {
                if (res.status === 0) {
                  this.$message.success(res.info.message)
                  this.$emit('refreshTable')
                  this.cancel()
                } else {
                  this.$message.error(res.info.message)
                }
              })
            }
          })
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      // const data = this.model
      const data = {
        id: this.model.id
      }
      getInvoice(data).then(res => {
        if (res.status === 0) {
          this.$nextTick(() => {
            // 获取收款列表
            this.getCollectionList(res.data.contractId)
            let invoicePayList = []
            if (res.data.payState) {
              if (res.data.invoicePayList.length > 0) {
                invoicePayList = res.data.invoicePayList.map(item => {
                  return item.payId
                })
              }
              this.collectionShow = true
            } else {
              this.collectionShow = false
            }
            this.form.setFieldsValue({
              contractId: res.data.contractId,
              contractMoney: res.data.contractMoney,
              operatorId: res.data.operatorId,
              companyName: res.data.companyName,
              invoiceType: res.data.invoiceType,
              invoiceTime: res.data.invoiceTime ? moment(res.data.invoiceTime).format('YYYY-MM-DD') : undefined,
              taxPoint: res.data.taxPoint,
              invoiceMoney: res.data.invoiceMoney,
              payState: res.data.payState,
              fileList: res.data.fileList,
              invoicePayList: invoicePayList
            })
          })
          this.payState = res.data.payState
          // 合同名称
          this.contractName = res.data.contractName
          // 经办人姓名
          this.operatorName = res.data.operatorName
          // 甲方id
          this.companyId = res.data.companyId
          this.fileList = res.data.fileList
        } else {
          this.$message.error('获取开票详情失败！')
        }
      })
    },
    // 获取关联收款
    getCollectionList (contractId) {
      this.collectionList = []
      getCollection({ paging: false, type: 2, contractId: contractId }).then(res => {
        res.data.forEach(item => {
          const obj = {
            id: item.id,
            payNo: item.payNo,
            payMoney: item.payMoney
          }
          this.collectionList.push(obj)
        })
      })
    },
    // 合同变更
    partyChange (id) {
      const index = this.contractList.findIndex(item => item.id === id)
      this.form.setFieldsValue({
        // 甲方名称
        companyName: this.contractList[index].partyName,
        // 合同金额
        contractMoney: this.contractList[index].contractAmount,
        // 经办人Id
        operatorId: this.contractList[index].operatorId
      })
      // 甲方id
      this.companyId = this.contractList[index].partyId
      // 合同名称
      this.contractName = this.contractList[index].name
      // 经办人姓名
      this.operatorName = this.contractList[index].operatorName
      // 获取收款列表
      this.getCollectionList(id)
    },
    // 经办人变更
    operatorIdChange (id) {
      const index = this.operatorList.findIndex(item => item.id === id)
      // 经办人姓名
      this.operatorName = this.operatorList[index].userName
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.able = false
        this.model = {}
        // 附件列表
        this.fileList = []
        // 收款列表
        this.collectionList = []
        // 合同名称
        this.contractName = ''
        // 经办人姓名
        this.operatorName = ''
        // 甲方id
        this.companyId = ''
        // 是否显示打包下载按钮
        this.downloadZipShow = false
        // 是否显示关联收款
        this.collectionShow = false
        // this.$refs.uploader.clearFileList()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    handleUpload (fileList) {
      this.fileList = fileList
      // 文件上传后同步更新表单的fileList
      this.form.setFieldsValue({
        fileList: this.fileList
      })
    },
    // 调用打包下载方法
    downloadZip () {
      downloadInvoiceFile(this.model.id).then(res => {
        var blob = new Blob([res])
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = '开票附件.zip'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      })
    },
    // 是否已收款改变判断
    changePayState (val) {
      this.payState = val
      // 如果是则显示关联收款
      if (val) {
        this.collectionShow = true
      } else {
        this.collectionShow = false
      }
    }
  }
}
</script>
<style lang="less">
</style>
